import {
  CommandLineIcon,
  HomeIcon,
  PencilIcon,
  PlusIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";

export const LOGGED_IN_ITEMS = [
  { name: "Vytvořit nového", href: "", icon: PlusIcon },
  { name: "Zobrazit", href: "/hlidaci-pes", icon: null },
];
export const OTHER_ITEMS = [
  { name: "Spravovat existujícího", href: "", icon: null },
  { name: "Přidat transakci", href: "", icon: PlusIcon },
  { name: "Upravit nemovitost", href: "", icon: PencilIcon },
];
export const USER_ESTATE_ITEMS = [
  { name: "Přidat nemovitost", href: "", icon: PlusIcon },
  { name: "Zobrazit", href: "/portfolio", icon: HomeIcon },
];
export const ADMIN_ITEMS = [
  { name: "Přepnout uživatele", href: "", icon: UserGroupIcon },
  { name: "Logy", href: "/logy", icon: CommandLineIcon },
];
